import { getFieldErrorMessage } from '@hypeit-gmbh/hypeit-ui';
import { TextInput, TextInputProps } from '@mantine/core';
import { Controller, FieldValues, Path, useFormContext } from 'react-hook-form';
import { addDateSeparators } from './helpers';

type DateFieldPropsType<T extends FieldValues> = Omit<
  TextInputProps,
  'name'
> & {
  fieldName: Path<T>;
};

export const DateField = <T extends FieldValues>({
  fieldName,
  ...props
}: DateFieldPropsType<T>): React.ReactElement => {
  const {
    control,
    formState: { errors },
  } = useFormContext<T>();

  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field }) => (
        <TextInput
          {...field}
          name={fieldName}
          onChange={(e) =>
            e.target.value === ''
              ? field.onChange(null)
              : field.onChange(addDateSeparators(e.target.value))
          }
          error={getFieldErrorMessage(errors, fieldName)}
          value={field.value ?? ''}
          {...props}
        />
      )}
    />
  );
};
